import React, { useState } from "react";
import {
  Box,
  Typography,
  Stack,
  useMediaQuery,
  IconButton,
  Menu,
  MenuItem,
  Badge,
} from "@mui/material";
import { colors } from "../../theme/theme";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { deletePost, getAllPosts } from "../../redux/actions/posts.dispatcher";
import SubscribeVideoDrawer from "../Common/SubscribeVideoDrawer";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { ConfirmationSnackbar, ErrorSnackbar } from "../Common/CustomSnackbar";
import axiosInstance from "../../utils/config/config";
import {
  AddComment,
  ConstructionOutlined,
  ThumbUpAltSharp,
} from "@mui/icons-material";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const SingleVideo = ({
  item,
  videoRef,
  onPlayPause,
  isPlaying,
  borderRadius,
  smallPlayBtn,
  noCreator = false,
  setPaidVideoData,
  fetchUserPosts,
  paid,
  markPostActive,
  markPostInactive,
  smallH,
  dontShowActions,
  pageNo,
  refreshFunction,
}) => {
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const [errorState, setErrorState] = useState({ error: false, message: "" });
  const [showComments, setShowComments] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [comments, setComments] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [successState, setSuccessState] = useState({
    success: false,
    message: "",
  });
  const [drawerState, setDrawerState] = useState(false);
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [success, setSuccess] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState({});
  const { userData } = useSelector((state) => state.user);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate("/creator/edit-content", {
      state: {
        editItem: item,
      },
    });
  };
  const handleSubmitRequest = (content) => {
    navigate("/submit-request", {
      state: {
        content: content,
      },
    });
  };

  const fetchComments = async (postId) => {
    setCommentsLoading(true);
    try {
      const response = await axiosInstance.get(
        `/post/comments?postId=${postId}`
      );

      setComments(response.data || []);
    } catch (err) {
      setErrorState({ error: true, message: "Failed to load comments." });
    } finally {
      setCommentsLoading(false);
    }
  };

  const handleAddComment = async () => {
    if (!newComment.trim()) return;

    try {
      await axiosInstance.post("/post/addComment", {
        postId: item.id,
        comment: newComment.trim(),
      });

      setSuccessState({
        success: true,
        message: "Comment added",
      });

      setNewComment("");

      fetchComments(item.id);

      setSuccessState({
        success: true,
        message: "Comment added succesfully.",
      });
    } catch (err) {
      setErrorState({
        error: true,
        message: "Failed to add comment",
      });
    }
  };
  const handleLikesButtonClick = async (postId) => {
    try {
      const response = await axiosInstance.post("/post/togglePostLikes", {
        postId,
      });

      if (response.status === 200) {
        if (response.data.message === "Post Liked") {
          setSuccessState({
            success: true,
            message: "Post Liked.",
          });
        } else {
          setSuccessState({
            success: true,
            message: "Post Unliked.",
          });
        }

        if (refreshFunction) {
          refreshFunction();
        } else {
          dispatch(getAllPosts(1));
        }
      }
    } catch (err) {
      console.log("error liking post", err);
      setErrorState({
        error: true,
        message: "Error while liking post, pls try again.",
      });
    }
  };

  const handleDelete = async () => {
    try {
      const del = await deletePost(item.id);

      fetchUserPosts();
    } catch (err) {
      console.log(err);
    }
  };

  const savePost = async (postId) => {
    try {
      const response = await axiosInstance.post("/post/savePost", {
        postId,
      });
    } catch (error) {
      console.log(error);
      setErrorState({ error: true, message: "Error Saving Post." });
    }
  };

  const userHasLiked = item?.likes?.some(
    (like) => like.userId === userData?.id
  );

  const openCommentOverlay = () => {
    setShowComments(true);
    fetchComments(item.id);
  };

  return (
    <Elements stripe={stripePromise}>
      <Box
        sx={{
          width: "100%",
          maxWidth: "600px",
          position: "relative",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          mb: 4,
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <ErrorSnackbar
          error={errorState.error}
          errorMsg={errorState.message}
          handleCloseError={() => setErrorState({ error: false, message: "" })}
        />
        <ConfirmationSnackbar
          snackbarState={successState.success}
          handleSnackbarClose={() =>
            setSuccessState({ success: false, message: "" })
          }
          text={successState.message}
        />
        {/* Image Section */}
        <Box sx={{ position: "relative" }}>
          {item?.video ? (
            <video
              ref={videoRef}
              src={item.video}
              autoPlay={false}
              style={{
                width: "100%",
                height: smallH ? (smallScreen ? "300px" : "400px") : "600px",
                zIndex: 2,
                position: "relative",
                borderRadius: borderRadius ? "8px" : "0px",
                objectFit: "cover",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
              controls={false}
              onEnded={onPlayPause}
            />
          ) : null}
          {/* Play Button */}
          {(isHovered || !isPlaying) && (
            <Box
              onClick={() => {
                debugger;
                if (!item?.video) return null;

                const isPPV =
                  item.visibility === "payPerView" ||
                  item.visibility === "payPerViewToEveryone";
                const isSubscription = item.visibility === "paid";
                const isFree = item.visibility === "freeToEveryone";
                const isCreator = userData.id === item.createdBy;
                const hasAccess = isCreator || item?.hasPurchased;
                const isAdmin = userData.role === "admin";

                if (isCreator || isAdmin) {
                  onPlayPause();
                } else if (isFree) {
                  onPlayPause(); // 🔓 Always allow
                } else if (isPPV) {
                  if (hasAccess) {
                    onPlayPause();
                  } else {
                    if (smallScreen) {
                      navigate("/subscriptionform/video", {
                        state: { paidVideoData: item },
                      });
                    } else {
                      setDrawerState(true);
                      setSelectedVideo(item);
                    }
                  }
                } else if (isSubscription) {
                  if (paid) {
                    onPlayPause();
                  } else {
                    if (smallScreen) {
                      navigate("/subscriptionform/creator", {
                        state: { creatorData: item.creator },
                      });
                    } else {
                      setDrawerState(true);
                      setSelectedVideo(item);
                    }
                  }
                } else {
                  if (hasAccess) {
                    onPlayPause();
                  }
                }
              }}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "rgba(0, 0, 0, 0.1)",
                border: "1px solid rgba(255, 255, 255)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: smallPlayBtn ? 2 : 4,
                py: smallPlayBtn ? 1 : 2,
                zIndex: 2,
                borderRadius: smallPlayBtn ? "10px" : "0px",
                cursor: "pointer",
              }}
            >
              <Typography
                sx={{
                  fontSize: smallPlayBtn ? 20 : 30,
                  fontWeight: 600,
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                {isPlaying ? "❚❚" : "▶"}
              </Typography>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            position: "absolute",
            zIndex: 3,
            bottom: 0,
            left: 0,
            width: "100%",
            backgroundImage:
              "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.479955) 27.72%, #000000 81.28%)",
            color: "#fff",
            p: 2,
            borderRadius: borderRadius ? "8px" : "0px",
          }}
        >
          {/* Tags */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            {item?.tags.map((tag, index) => (
              <Typography
                key={index}
                sx={{
                  color: colors.primary,
                  fontSize: smallScreen ? 12 : 16,
                  fontFamily: "Inter-Regular",
                }}
              >
                {"#" + tag}
              </Typography>
            ))}
          </Box>
          {/* Title */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontSize: smallScreen ? 16 : 28,
                  fontWeight: 600,
                  fontFamily: "Inter-SemiBold",
                  lineHeight: smallScreen ? "18px" : "35px",
                }}
              >
                {item?.title}
              </Typography>

              <Typography
                sx={{
                  fontSize: smallScreen ? 14 : 16,
                  color: "#FFFFFF99",
                  mb: 1,
                  fontFamily: "Inter-Regular",
                }}
              >
                {item?.description}
              </Typography>
            </Box>

            {item?.creator?.id === userData?.id && (
              <>
                <IconButton
                  aria-controls={open ? "post-actions-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  sx={{ color: "#fff" }}
                >
                  <MoreVertIcon />
                </IconButton>

                <Menu
                  id="post-actions-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "more-button",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      try {
                        const url = `${process.env.REACT_APP_STAGING_FRONTEND_URL}/post/${item.id}`;
                        navigator.clipboard.writeText(url);

                        setSuccessState({
                          success: true,
                          message: "Post URL copied.",
                        });
                      } catch (err) {
                        setErrorState({
                          error: true,
                          message: "Error copying URL.",
                        });
                      }
                    }}
                  >
                    Share
                  </MenuItem>
                  <MenuItem onClick={handleEdit}>Edit</MenuItem>
                  <MenuItem onClick={handleDelete}>Delete</MenuItem>
                </Menu>
              </>
            )}
            {item?.creator?.id !== userData?.id &&
              userData.role !== "admin" && (
                <>
                  {!dontShowActions && (
                    <Box>
                      <IconButton
                        onClick={() => {
                          handleLikesButtonClick(item.id);
                        }}
                      >
                        <ThumbUpAltSharp
                          sx={{ color: userHasLiked ? "#FC1018" : "white" }}
                        />
                      </IconButton>
                      <IconButton onClick={openCommentOverlay}>
                        <AddComment sx={{ color: "#FC1018" }} />
                      </IconButton>
                    </Box>
                  )}

                  <IconButton
                    aria-controls={open ? "post-actions-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    sx={{ color: "#fff" }}
                  >
                    <MoreVertIcon />
                  </IconButton>

                  <Menu
                    id="post-actions-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "more-button",
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        try {
                          const url = `${process.env.REACT_APP_STAGING_FRONTEND_URL}/post/${item.id}`;
                          navigator.clipboard.writeText(url);

                          setSuccessState({
                            success: true,
                            message: "Post URL copied.",
                          });
                        } catch (err) {
                          setErrorState({
                            error: true,
                            message: "Error copying URL.",
                          });
                        }
                      }}
                    >
                      Share
                    </MenuItem>
                    <MenuItem onClick={() => navigate(`/post/${item.id}`)}>
                      View Post
                    </MenuItem>
                    <MenuItem onClick={() => savePost(item.id)}>Save</MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleSubmitRequest(item);
                      }}
                    >
                      Report
                    </MenuItem>
                  </Menu>
                </>
              )}
            {userData.role === "admin" && (
              <>
                <IconButton
                  aria-controls={open ? "post-actions-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  sx={{ color: "#fff" }}
                >
                  <MoreVertIcon />
                </IconButton>

                <Menu
                  id="post-actions-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "more-button",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      if (item.status === "active") {
                        markPostInactive(item.id);
                      } else {
                        markPostActive(item.id);
                      }
                    }}
                  >
                    {item.status === "active" ? "Mark Inactive" : "Mark Active"}
                  </MenuItem>
                </Menu>
              </>
            )}
          </Box>
          {/* Creator */}
          {!noCreator && (
            <Stack
              direction="row"
              spacing={2}
              sx={{
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <img
                src={
                  item?.creator?.avatar ||
                  require("../../assets/images/user.jpg")
                }
                alt="creator"
                style={{
                  borderRadius: "50%",
                  width: 40,
                  height: 40,
                  objectFit: "contain",
                }}
              />
              <Typography
                sx={{
                  fontSize: 16,
                  color: "#fff",
                  fontFamily: "Inter-Regular",
                }}
                className="step-2-2"
                onClick={() => {
                  if (item?.creator?.id == userData.id) {
                    navigate(`/creator/${userData?.id}`);
                  } else {
                    if (userData.role === "admin") {
                      navigate(`/admin/profile/${item?.creator?.id}`);
                    } else {
                      navigate(`/profile/${item?.creator?.id}`);
                    }
                  }
                }}
              >
                {item?.creator?.firstName + " " + item?.creator?.lastName}
              </Typography>
              <Box
                sx={{
                  backgroundColor: "#fc1018",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 500,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "12px",
                  whiteSpace: "nowrap",
                }}
              >
                {item.visibility === "payPerView" ||
                item.visibility === "payPerViewToEveryone"
                  ? "Pay Per View"
                  : "Available"}
              </Box>
            </Stack>
          )}
          {/* Usernames */}
          {/* <Typography
          sx={{
            fontSize: 12,
            color: "rgba(255, 255, 255, 0.5)",
            mb: 2,
            fontFamily: "Inter-Regular",
          }}
        >
          @williamson5 @john100 @john100
        </Typography> */}
          {/* Actions */}
          {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconButton
              sx={{
                color: "#fff",
              }}
            >
              <ThumbUpOutlined />
            </IconButton>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: 14,
                color: "rgba(255, 255, 255, 0.7)",
              }}
            >
              1.3k
            </Typography>
            <IconButton
              sx={{
                color: "#fff",
              }}
            >
              <ThumbDownOutlined />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                fontFamily: "Inter-Regular",
                color: "#fff",
              }}
            >
              Add to Playlist
            </Typography>

            <Add />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                fontFamily: "Inter-Regular",
                color: "#fff",
              }}
            >
              Share
            </Typography>

            <Reply />
          </Box>
        </Box> */}
        </Box>
        <SubscribeVideoDrawer
          drawerState={drawerState}
          setDrawerState={setDrawerState}
          paidVideoData={selectedVideo}
          setSuccess={setSuccess}
          type="video"
          creatorData={userData}
        />
        {showComments && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 5,
              backgroundColor: "rgba(0, 0, 0, 0.9)",
              color: "#fff",
              p: 2,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
            >
              <Typography variant="h6">Comments</Typography>
              <IconButton
                onClick={() => setShowComments(false)}
                sx={{ color: "#fff" }}
              >
                ✕
              </IconButton>
            </Box>

            <Box sx={{ flex: 1, overflowY: "auto", pr: 1 }}>
              {commentsLoading ? (
                <Typography>Loading comments...</Typography>
              ) : comments.length > 0 ? (
                comments.map((comment, idx) => (
                  <Box key={idx} sx={{ mb: 2 }}>
                    <Typography fontWeight={600} sx={{ color: "#FC1018" }}>
                      {comment.User?.firstName} {comment.User?.lastName}
                    </Typography>
                    <Typography variant="body2">{comment.comment}</Typography>
                    <Typography variant="caption" color="gray">
                      {new Date(comment.createdAt).toLocaleString()}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography>No comments yet.</Typography>
              )}
            </Box>

            <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
              <input
                type="text"
                placeholder="Write a comment..."
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRadius: "4px",
                  border: "none",
                  color: "black",
                }}
              />
              <button
                onClick={handleAddComment}
                style={{
                  backgroundColor: "#FC1018",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Send
              </button>
            </Box>
          </Box>
        )}
      </Box>
    </Elements>
  );
};

export default SingleVideo;
